import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Description' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 16
    },
    short: {
        margin: 0,
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        color: '#2D2D2D',
        transition: 'all 0.3s',
        opacity: 1
    },
    pale: {
        opacity: 0.7
    },
    full: {
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        color: '#2D2D2D',
        overflow: 'hidden',
        ['& a']: {
            color: theme.palette.primary.main,
            textDecoration: 'none'
        },
        ['& img']: {
            maxWidth: '100%'
        },
        ['& code']: {
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            padding: 20,
            borderRadius: 18,
            background: '#38383A',
            fontSize: 13,
            lineHeight: '15px'
        },
        ['& ul']: {
            maxHeight: 300,
            overflowY: 'scroll',
            scrollbarWidth: 'none', // Firefox
            ['&::-webkit-scrollbar']: {
                display: 'none' // Safari and Chrome
            }
        }
    },
    skeleton: {
        lineHeight: '21px'
    },
    added: {
        background: '#E5F6ED'
    },
    removed: {
        background: '#FFEBED'
    }
}));
